{
  "primer": {
    "eyebrow": "Heures de prière et Qibla",
    "headline": "Rhemn a besoin de votre position pour les heures de prière et la Qibla.",
    "body": "Nous l'utilisons pour vos heures de prière, la direction de la Qibla et la météo locale — rien d'autre.",
    "cta": "Continuer",
    "skip": "Pas maintenant",
    "skip_body": "Les heures de prière et la Qibla resteront désactivées."
  }
}
